import React from 'react';
import {  FiStar, FiTrash2 } from "react-icons/fi";
import { langList } from './mock';
export const Languages = ({type=''}) =>{

    const [list,setList] = React.useState([])
    
    React.useEffect(()=>{// preloading
        let newList = []
        langList.map(list=>{
            let correct = langList.find((l)=>l.title === list.title)
            if(correct){
                newList.push({...list, active:true})
            }else{
                newList.push({...list, active:false})

            }
            return true;
        })
         setList(newList)

    },[])

    const toggle =  async (item) =>{
        const listItem = list.find((l)=>l.id===item.id)
        const listIndex = list.findIndex((l)=>l.id===item.id)

        if(listItem?.active){
            list.splice(listIndex, 1, {...item, active:false})
            remove(item.title)
        }else{
            list.splice(listIndex, 1, {...item, active:true})


            const isHave = langList.find((l)=>l.id===item.id) || false
            if(isHave){
                remove(item.title)
            }else{}
            
        
        }

    }

    
    const update =  async (item,star) => {
        let newList = [...langList]
        let itemIndex = newList.findIndex((l)=>l.title===item.title)
        newList.splice(itemIndex,1,{...item,star})
    }

    const remove =  async (title) => {
        change(title)
    }

    const change = (title) =>{
        const listItem = list.find((l)=>l.title===title)
        const listIndex = list.findIndex((l)=>l.title===title)
        list.splice(listIndex, 1, {...listItem, active:false})
    }


    return (
        <div className="lang_component">

            <h3 className="">Foreign langauges</h3> <br />
            <div className="row">
                <div className="col-12">

                    <div className="languages">
                        <ul>
                            {list.map((item,i)=>(
                                <li key={'language'+i} className={`${item.active===true&&'active'}`} onClick={()=>{
                                    toggle(item)
                                }}>{item.title}</li>
                            ))}
                        </ul>
                    </div>


                    <div className="languages_chosen">
                        <ul>
                            {langList?.filter((l)=>l.type===type).map((item,i)=>(
                                <li key={'lang'+i}>
                                    <div className="trash" onClick={()=>{  remove(item.title) }}><FiTrash2 size={20} /></div> 

                                    <div>{item.title}</div>
                                    <div className="stars">{Array.from(Array(5), (element, index)=><FiStar key={`${element}-${index}`} className={`star ${index >= (item?.star || 0) && 'gray'}`} onClick={()=>{
                                        
                                        update(item,++index)

                                    }} />)}</div>
                                   
                                </li>
                            ))}
                        </ul>
                    </div>
                 </div>
            </div>
        </div>
    )
}
 